import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
/**
 * Renders a button which, when selected, will open a popup for logout
 */
const alignRight = {
    marginLeft: 'auto'
}
export const SignOutButton = () => {
    var { instance } = useMsal();
    const { t } = useTranslation();

    const handleLogout = (logoutType) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    return (
        <Button variant="secondary" style={alignRight} onClick={() => handleLogout("popup")}>{t("create_signtask_nav_logout")}</Button>
    );
}